import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getSessionAuth } from './session';

/**
 * Role app switcher — only shows shells the user can actually use.
 */
export default function AppSwitcher({ className = '' }) {
    const { t } = useTranslation();
    const auth = getSessionAuth();
    const location = useLocation();
    const links = [];

    links.push({ to: '/learn', label: t('shell.appSwitcher.learner') });

    const canStudio = Boolean(
        auth.orgRole === 'instructor'
        || auth.orgRole === 'org_admin'
        || auth.role === 'instructor'
        || auth.role === 'teacher'
        || auth.role === 'admin'
        || auth.platformAdmin
    );
    const canOrg = Boolean(auth.orgRole === 'org_admin' || auth.platformAdmin);
    const canPlatform = Boolean(auth.platformAdmin);

    if (canStudio) links.push({ to: '/studio', label: t('shell.appSwitcher.studio') });
    if (canOrg) links.push({ to: '/org/admin', label: t('shell.appSwitcher.org') });
    if (canPlatform) links.push({ to: '/super-admin', label: t('shell.appSwitcher.platform') });

    if (links.length <= 1) return null;

    return (
        <div className={`flex p-0.5 rounded-lg bg-slate-100/90 border border-slate-200/80 ${className}`}>
            {links.map((l) => {
                const active = location.pathname === l.to || location.pathname.startsWith(`${l.to}/`);
                return (
                    <Link
                        key={l.to}
                        to={l.to}
                        className={`flex-1 text-center text-[11px] px-1.5 py-1.5 rounded-md font-semibold transition ${
                            active
                                ? 'bg-white text-slate-900 shadow-sm'
                                : 'text-slate-500 hover:text-slate-800'
                        }`}
                    >
                        {l.label}
                    </Link>
                );
            })}
        </div>
    );
}
